module.exports = __webpack_public_path__ + "img/advantage_desc.430e54da.png";